import { render, staticRenderFns } from "./ShiftList.vue?vue&type=template&id=591aa2fb&scoped=true&lang=pug&"
import script from "./ShiftList.vue?vue&type=script&lang=ts&"
export * from "./ShiftList.vue?vue&type=script&lang=ts&"
import style0 from "./ShiftList.vue?vue&type=style&index=0&id=591aa2fb&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591aa2fb",
  null
  
)

export default component.exports